(() => {
  if (window.HugfigProductTotal) return;

  function parseVariant(productInfo) {
    try {
      return JSON.parse(productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null');
    } catch (_error) {
      return null;
    }
  }

  function parseVariants(productInfo) {
    try {
      return JSON.parse(productInfo.querySelector('variant-selects [data-hugfig-variants]')?.textContent || '[]');
    } catch (_error) {
      return [];
    }
  }

  function selectedVariantFromInputs(productInfo) {
    const selectedOptions = Array.from(
      productInfo.querySelectorAll('variant-selects .product-form__input')
    ).map((fieldset) => fieldset.querySelector('input:checked, option:checked')?.value).filter(Boolean);
    if (!selectedOptions.length) return null;
    return parseVariants(productInfo).find((variant) =>
      variant.options?.every((option, index) => option === selectedOptions[index])
    ) || null;
  }

  function extrasTotal(productInfo) {
    let total = 0;

    for (const checkbox of productInfo.querySelectorAll('.hugfig-gift-ready-bundle__checkbox:checked')) {
      total += Number.parseInt(checkbox.dataset.price, 10) || 0;
    }

    const keychain = productInfo.querySelector('.hugfig-keychain-option.is-selected');
    if (keychain) total += Math.round((Number.parseFloat(keychain.dataset.price) || 0) * 100);
    return total;
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (_error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function sizeKeyFromValue(value) {
    const normalizedValue = String(value || '');
    if (normalizedValue.includes('10 cm')) return '10';
    if (normalizedValue.includes('8 cm')) return '8';
    return '6';
  }

  function sizeKeyFromVariant(variant) {
    return sizeKeyFromValue(variant?.option2 || variant?.options?.[1]);
  }

  function selectedSizeKey(productInfo) {
    const sizeInput = Array.from(
      productInfo.querySelectorAll('variant-selects input[data-option-name="Size"]:checked')
    ).find((input) => input.value.includes('6 cm') || input.value.includes('8 cm') || input.value.includes('10 cm'));
    return sizeInput ? sizeKeyFromValue(sizeInput.value) : null;
  }

  function updateTypePrices(productInfo, currency, sizeKey = '6') {
    for (const priceElement of productInfo.querySelectorAll('[data-hugfig-type-price]')) {
      if (priceElement.querySelector('[data-hugfig-price-size]')) continue;
      const cents = Number.parseInt(priceElement.dataset[`price${sizeKey}`], 10);
      if (Number.isFinite(cents)) priceElement.textContent = formatMoney(cents, currency);
    }

    for (const linkedType of productInfo.querySelectorAll('[data-hugfig-linked-type]')) {
      const variantId = linkedType.dataset[`variant${sizeKey}`];
      if (!variantId) continue;
      const destination = new URL(linkedType.href, window.location.origin);
      destination.searchParams.set('variant', variantId);
      linkedType.href = `${destination.pathname}${destination.search}`;
    }
  }

  function setPendingSizeKey(productInfo, sizeKey) {
    productInfo.dataset.hugfigPendingSizeKey = sizeKey;
  }

  function pendingSizeKey(productInfo, variant) {
    const sizeKey = productInfo.dataset.hugfigPendingSizeKey || sizeKeyFromVariant(variant);
    delete productInfo.dataset.hugfigPendingSizeKey;
    return sizeKey;
  }

  function update(productInfo, selectedVariant = null, selectedSizeKey = null) {
    const variant = selectedVariant || parseVariant(productInfo);
    if (!variant) return;

    const currency = productInfo.querySelector('variant-selects')?.dataset.currencyCode || 'USD';
    const currencyCodeEnabled = productInfo.querySelector('variant-selects')?.dataset.currencyCodeEnabled === 'true';
    const total = (Number.parseInt(variant.price, 10) || 0) + extrasTotal(productInfo);
    const formatted = formatMoney(total, currency);
    const formattedWithCurrency = currencyCodeEnabled ? `${formatted} ${currency}` : formatted;
    const sizeKey = selectedSizeKey || pendingSizeKey(productInfo, variant);
    updateTypePrices(productInfo, currency, sizeKey);
    const price = productInfo.querySelector('[id^="price-"] .price__sale .price-item--sale')
      || productInfo.querySelector('[id^="price-"] .price__regular .price-item--regular');
    if (price) price.textContent = formattedWithCurrency;

    const savingsBadge = productInfo.querySelector('[id^="price-"] .price__save-badge-orange');
    const comparePrice = Number.parseInt(variant.compare_at_price, 10) || 0;
    const comparePriceElement = productInfo.querySelector('[id^="price-"] .price__sale .price-item--regular');
    if (comparePriceElement && comparePrice > 0) {
      const formattedComparePrice = formatMoney(comparePrice, currency);
      comparePriceElement.textContent = currencyCodeEnabled
        ? `${formattedComparePrice} ${currency}`
        : formattedComparePrice;
    }
    if (savingsBadge) {
      const savings = comparePrice - total;
      savingsBadge.hidden = savings <= 0;
      savingsBadge.classList.toggle('hidden', savings <= 0);
      if (savings > 0) {
        const formattedSavings = formatMoney(savings, currency);
        savingsBadge.textContent = `SAVE ${currencyCodeEnabled ? `${formattedSavings} ${currency}` : formattedSavings}`;
      }
    }

    const addToCart = productInfo.querySelector('.product-form__submit-text');
    if (addToCart) addToCart.textContent = `Add to cart (${formatted})`;
  }

  function updateOptimistically(productInfo) {
    const variant = selectedVariantFromInputs(productInfo);
    if (!variant) return;
    const sizeKey = selectedSizeKey(productInfo) || sizeKeyFromVariant(variant);
    update(productInfo, variant, sizeKey);
  }

  function updateAll() {
    for (const productInfo of document.querySelectorAll('product-info')) {
      const sizeKey = selectedSizeKey(productInfo);
      update(productInfo, null, sizeKey);
    }
  }

  document.addEventListener('change', (event) => {
    const productInfo = event.target.closest('product-info');
    if (!productInfo) return;
    if (event.target.closest('variant-selects')) {
      updateOptimistically(productInfo);
      if (event.target.dataset.optionName === 'Size') {
        const currency = productInfo.querySelector('variant-selects')?.dataset.currencyCode || 'USD';
        const sizeKey = sizeKeyFromValue(event.target.value);
        setPendingSizeKey(productInfo, sizeKey);
        updateTypePrices(productInfo, currency, sizeKey);
        window.setTimeout(() => updateTypePrices(productInfo, currency, sizeKey), 550);
      }
      return;
    }
    if (event.target.closest('.hugfig-gift-ready-bundle')) window.requestAnimationFrame(updateAll);
  });
  document.addEventListener('hugfig:addons-change', updateAll);
  document.addEventListener('product-info:loaded', updateAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = Array.from(document.querySelectorAll('product-info'))
        .find((element) => element.dataset.section === data.sectionId);
      if (!productInfo || !data.variant) return;
      const sizeKey = productInfo.dataset.hugfigPendingSizeKey || sizeKeyFromVariant(data.variant);
      const updateSelectedVariant = () => update(productInfo, data.variant, sizeKey);
      window.requestAnimationFrame(updateSelectedVariant);
      window.setTimeout(updateSelectedVariant, 550);
    });
  }

  window.HugfigProductTotal = { updateAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }
})();
